import * as XLSX from 'xlsx';

const sanitizeSheetName = (name = 'Sheet') => {
  const cleaned = String(name || 'Sheet').replace(/[\\/?*[\]:]/g, ' ').trim();
  return (cleaned || 'Sheet').slice(0, 31);
};

const ensureUniqueSheetName = (workbook, name) => {
  const base = sanitizeSheetName(name);
  let next = base;
  let index = 1;
  while (workbook.SheetNames.includes(next)) {
    const suffix = ` ${index}`;
    next = `${base.slice(0, 31 - suffix.length)}${suffix}`;
    index += 1;
  }
  return next;
};

const normalizeRows = (rows = []) => {
  if (!Array.isArray(rows)) return [];
  return rows.map((row) => {
    if (row && typeof row === 'object' && !Array.isArray(row)) return row;
    return { value: row };
  });
};

export const downloadWorkbook = (sheets = [], fileName = 'chart_data.xlsx') => {
  const workbook = XLSX.utils.book_new();
  const validSheets = sheets.filter((sheet) => sheet && Array.isArray(sheet.rows) && sheet.rows.length > 0);

  if (validSheets.length === 0) {
    const worksheet = XLSX.utils.json_to_sheet([{ message: 'No data available' }]);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
  } else {
    validSheets.forEach((sheet) => {
      const worksheet = XLSX.utils.json_to_sheet(normalizeRows(sheet.rows));
      XLSX.utils.book_append_sheet(workbook, worksheet, ensureUniqueSheetName(workbook, sheet.name));
    });
  }

  XLSX.writeFile(workbook, fileName.endsWith('.xlsx') ? fileName : `${fileName}.xlsx`);
};

export const downloadRowsAsWorkbook = (rows = [], title = 'chart_data') => {
  downloadWorkbook([{ name: title, rows }], `${title}_data.xlsx`);
};
